import React from 'react';

import Loader from '../../../../components/Loader';
import Modal from '../../../../components/Model';
import { Roles } from '../../../../util/constant';
import useDailyTask from '../useDailyTask';

const DailyTask: React.FC = () => {
  const {
    loading,
    data,
    setIsModalOpen,
    isModalOpen,
    comments,
    setComments,
    setSelectedTaskId,
    selectedDate,
    handleDateChange,
    handleAddComment,
    calculateTotalHoursAndMinutes,
    localTaskHours,
    setLocalTaskHours,
  } = useDailyTask();

  const Role = localStorage.getItem("role");
  console.log(Role);
  // Group tasks by project
  const groupTasksByProject = (tasks: any[]) => {
    return tasks.reduce((acc: any, task: any) => {
      const projectName = task.projectId?.name || "Unassigned";
      if (!acc[projectName]) {
        acc[projectName] = [];
      }
      acc[projectName].push(task);
      return acc;
    }, {});
  };

  return (
    <div className="h-[87vh] p-3 rounded-lg bg-white overflow-y-scroll">
      <h6 className="text-lg font-semibold text-fontBlack">
        Daily End of Day (EOD) Report
      </h6>

      <div className="mb-4">
        <label htmlFor="startDate">Select Date:</label>
        <input
          type="date"
          id="startDate"
          value={selectedDate}
          onChange={handleDateChange}
          className="border p-2 ml-2"
        />
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="space-y-6">
          {data.length > 0 ? (
            data.map((taskData: any) => {
              const projects = groupTasksByProject(taskData?.todayTaskIds);
              return (
                <div key={taskData?._id} className="p-4 border rounded-lg">
                  <div className="flex justify-between">
                    <h2 className="font-bold text-xl mb-2">
                      {taskData?.userId?.name}
                    </h2>
                    {Role === Roles.admin && (
                      <button
                        onClick={() => {
                          setSelectedTaskId(taskData?._id);
                          setIsModalOpen(true);
                        }}
                        className="bg-blue-500 text-white px-4 py-2 rounded mb-4"
                      >
                        Add Comment
                      </button>
                    )}
                  </div>

                  {Object.entries(projects).map(([projectName, tasks]: any) => (
                    <div key={projectName} className=''>
                      <h3 className="font-semibold">{projectName}</h3>
                      <h3 className='text-sm text-red-500'>{calculateTotalHoursAndMinutes().displayHours} hours {calculateTotalHoursAndMinutes().displayMinutes} minutes</h3>

                      <table className="w-full border-collapse border mb-4">
                        <thead>
                          <tr>
                            <th className="border p-2">Task</th>
                            <th className="border p-2">Created At</th>
                            <th className="border p-2">Due Date</th>
                            <th className="border p-2">Hours</th>
                            <th className="border p-2">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tasks.map((task: any) => (
                            <tr key={task?._id}>
                              <td className="border p-2">
                                {task.description
                                  .split(" ")
                                  .map((word: string, index: number) => {
                                    if (word.includes("http")) {
                                      return (
                                        <span key={index}>
                                          {index > 0 && " "}
                                          <a
                                            href={word}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 hover:text-blue-700 underline"
                                          >
                                            {word}
                                          </a>
                                        </span>
                                      );
                                    }
                                    return (
                                      <span key={index}>
                                        {index > 0 && " "}
                                        {word}
                                      </span>
                                    );
                                  })}
                              </td>
                              <td className="border p-2">
                                {new Date(task?.createdAt).toLocaleDateString()}
                              </td>
                              <td className="border p-2">
                                {new Date(task?.dueDate).toLocaleDateString()}
                              </td>
                              <td className="border p-2">
                                {Math.floor(task?.hours)}:{(task?.hours % 1) * 60}
                              </td>
                              <td className="border p-2">{task?.status}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
                  <div className="flex justify-between mb-4">
                    <div className="w-1/2 pr-2">
                      <h3 className="font-semibold">Today Worked On:</h3>
                      <textarea
                        name="todayUpdate"
                        placeholder="Enter today's tasks..."
                        value={taskData.todayUpdate || "No update provided."}
                        className="border p-2 rounded w-full bg-gray-100"
                        rows={4}
                        disabled
                      />
                    </div>
                    <div className="w-1/2 pl-2">
                      <h3 className="font-semibold">Tomorrow's Plan:</h3>
                      <textarea
                        name="tomorrowUpdate"
                        placeholder="Enter tomorrow's tasks..."
                        value={taskData.tomorrowUpdate || "No update provided."}
                        className="border p-2 rounded w-full bg-gray-100"
                        rows={4}
                        disabled
                      />
                    </div>
                    <div className="w-1/3 pl-2">
                      <h3 className="font-semibold">last comment</h3>
                      <textarea
                        name="tomorrowUpdate"
                        placeholder="Enter tomorrow's tasks..."
                        value={comments || "No update provided."}
                        className="border p-2 rounded w-full bg-gray-100"
                        rows={4}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No tasks available for the selected date.</p>
          )}
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        <textarea
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          className="w-full p-2 border rounded"
          rows={4}
          placeholder="Enter your comment..."
        />
        <button
          onClick={() => {
            handleAddComment();
          }}
          className="bg-blue-500 text-white px-4 py-2 rounded mb-4"
        >
          Add Comment
        </button>
      </Modal>
    </div>
  );
};

export default DailyTask;
